import { ActivityFilterDiv, AllActivitiesDiv } from "./styles";
import { accordionData } from "./accordion-data";
import { Accordion } from "./components/Accordion";
import { SidebarProps } from "./types";
import { useState } from "react";

export const ActivitySidebar = (props: SidebarProps) => {
  const [isSelected, setIsSelected] = useState<string | undefined>(undefined);

  return (
    <ActivityFilterDiv>
      <AllActivitiesDiv
        selected={isSelected}
        onClick={() => {
          props.setCogDomainFilter(undefined);
          props.setCategoryFilter("");
          setIsSelected(undefined);
        }}
      >
        ALL ACTIVITIES
      </AllActivitiesDiv>
      {accordionData.map(({ title, content }, index) => (
        <Accordion
          title={title}
          content={content}
          key={index}
          setCogDomainFilter={props.setCogDomainFilter}
          setCategoryFilter={props.setCategoryFilter}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
        />
      ))}
    </ActivityFilterDiv>
  );
};
